import { useCallback, useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Divider, Paper, Typography } from '@mui/material';
import { Settings } from '../../../interfaces/Settings/Settings';
import { getSettingsByType, upsertSettings } from '../../../api/Settings';
import { SettingsType } from '../../../interfaces/Settings/SettingsType';
import { GenericSettingsValue } from '../../../interfaces/Settings/GenericSettingsValue';
import { getSettingsValue, getUpdatedSettings } from '../../../utils/Settings';
import { Waiting } from '../../../components/Waiting/Waiting';
import { sharedStyles } from '../../../utils/Style';
import { SettingsRow } from '../../../components/Settings/SettingsRow';
import { SettingsValueType } from '../../../interfaces/Settings/SettingsValueType';

const stockAlertKeys = ['stock_alert_subject', 'stock_alert_body'];

export const StockAlertSettings = () => {
  const [settings, setSettings] = useState<Settings[]>([]);
  const [loading, setLoading] = useState(true);

  const refreshSettings = () => {
    setLoading(true);
    getSettingsByType(SettingsType.MAIL_NOTIFICATION)
      .then((s) => setSettings(s))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshSettings();
  }, []);

  const handleChange = useCallback(
    (key: string, newValue: GenericSettingsValue) =>
      setSettings(
        getUpdatedSettings(
          SettingsType.MAIL_NOTIFICATION,
          key,
          settings,
          newValue,
        ),
      ),
    [settings],
  );

  const handleSave = () => {
    setLoading(true);
    upsertSettings(settings.filter((s) => stockAlertKeys.includes(s.key)))
      .then(() => {
        toast.success('Ayarlar başarıyla kaydedildi');
        refreshSettings();
      })
      .catch((err) => {
        toast.error(err.message);
        setLoading(false);
      });
  };

  return (
    <Paper
      sx={{
        p: 1.5,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        height: '95%',
      }}
    >
      <Waiting open={loading} />

      <Typography
        sx={{
          ...sharedStyles.h5,
          fontWeight: 'bold',
        }}
      >
        Stok Yenilenme E-Postası
      </Typography>
      <Divider />

      <SettingsRow
        name='E-Mail Başlığı'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'stock_alert_subject')}
        onChange={(newValue) => handleChange('stock_alert_subject', newValue)}
        multiline
        placeholder='Stoklar yenilendi!'
      />

      <SettingsRow
        name='E-Mail Mesajı'
        valueType={SettingsValueType.TEXT}
        value={getSettingsValue(settings, 'stock_alert_body')}
        onChange={(newValue) => handleChange('stock_alert_body', newValue)}
        multiline
        placeholder='Haberdar olmak istediğiniz ürünler tekrar stokta! Aşağıdan ürünlere göz atabilirsiniz.'
      />

      <Box sx={{ display: 'flex', flexGrow: 1 }} />

      <Box display='flex' justifyContent='flex-end'>
        <Button
          variant='contained'
          onClick={handleSave}
          sx={{ ...sharedStyles.buttonText, mt: 1.5 }}
        >
          Kaydet
        </Button>
      </Box>
    </Paper>
  );
};
